import * as React from 'react';

import { CRUDableType } from '@/meta';

import { RootStateDispatchContext, RootStateContext } from './global-controller';

/**
 * Used to force a refresh on current widgets
 */
function useRefreshController() {
  const dispatch = React.useContext(RootStateDispatchContext);
  const { cache } = React.useContext(RootStateContext);

  const refreshType = React.useCallback(
    (type: CRUDableType) => {
      dispatch({
        type: 'cache',
        data: {
          [type]: Date.now(),
        },
      });
    },
    [dispatch]
  );

  const getQuery = React.useCallback(
    (query: string, type: CRUDableType) => {
      if (type in cache) {
        return query ? `?${query}&cache=${cache[type]}` : `?cache=${cache[type]}`;
      }

      return query;
    },
    [cache]
  );

  return {
    cache,
    refreshType,
    getQuery,
  };
}

export default useRefreshController;
